var map = {
	"./template.bet575": 1871,
	"./template.bet575.tsx": 1871,
	"./template.bet777": 1872,
	"./template.bet777.tsx": 1872,
	"./template.betgalaxy": 1873,
	"./template.betgalaxy.tsx": 1873,
	"./template.betprofessor": 2053,
	"./template.betprofessor.tsx": 2053,
	"./template.betroyale": 1874,
	"./template.betroyale.tsx": 1874,
	"./template.betstride": 1875,
	"./template.betstride.tsx": 1875,
	"./template.buffalobet": 1876,
	"./template.buffalobet.tsx": 1876,
	"./template.chromabet": 1877,
	"./template.chromabet.tsx": 1877,
	"./template.default": 709,
	"./template.default.tsx": 709,
	"./template.epicodds": 1878,
	"./template.epicodds.tsx": 1878,
	"./template.fiestabet": 2007,
	"./template.fiestabet.tsx": 2007,
	"./template.gigabet": 1879,
	"./template.gigabet.tsx": 1879,
	"./template.goldenbet888": 1880,
	"./template.goldenbet888.tsx": 1880,
	"./template.goldenrush": 1881,
	"./template.goldenrush.tsx": 1881,
	"./template.hyperbet": 1882,
	"./template.hyperbet.tsx": 1882,
	"./template.juicybet": 2008,
	"./template.juicybet.tsx": 2008,
	"./template.junglebet": 2009,
	"./template.junglebet.tsx": 2009,
	"./template.magnumbet": 1883,
	"./template.magnumbet.tsx": 1883,
	"./template.oldgill": 1884,
	"./template.oldgill.tsx": 1884,
	"./template.puntcity": 1885,
	"./template.puntcity.tsx": 1885,
	"./template.puntgenie": 1886,
	"./template.puntgenie.tsx": 1886,
	"./template.pyramidbet": 1887,
	"./template.pyramidbet.tsx": 1887,
	"./template.questbet": 1888,
	"./template.questbet.tsx": 1888,
	"./template.slambet": 1889,
	"./template.slambet.tsx": 1889,
	"./template.sterlingparker": 1890,
	"./template.sterlingparker.tsx": 1890,
	"./template.sugarcastle": 2054,
	"./template.sugarcastle.tsx": 2054,
	"./template.templebet": 1891,
	"./template.templebet.tsx": 1891,
	"./template.titanbet": 1892,
	"./template.titanbet.tsx": 1892,
	"./template.ts": 997,
	"./template.vikingbet": 1893,
	"./template.vikingbet.tsx": 1893,
	"./template.volcanobet": 1894,
	"./template.volcanobet.tsx": 1894,
	"./template.wellbet": 1895,
	"./template.wellbet.tsx": 1895
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2793;